<template>
  <div
    class="time-clock-widget"
    v-show="!clockWidgetBtn"
    v-if="visibleTimeClock"
    @click="timeClockBtnClick"
  >
    <div class="widget-button" @mouseleave="mouseLeave">
      <button
        type="button"
        class="remove-button"
        v-show="showCloseBtn"
        @click="disableTimeClockWidget"
      >
        <img
          src="../../../images/small-remove-gray-button.svg"
          alt="Remove Widged"
        />
      </button>
      <transition name="fade">
        <div class="status" v-show="showTimer">
          <span
            class="status-ripple"
            :class="{ 'on-break': breakClockTimer }"
          ></span>
          <span class="counter">{{
            breakClockTimer ? breakClockTimer : timeClockTimer
          }}</span>
        </div>
      </transition>
      <button
        type="button"
        class="widget-icons-button"
        @click="toggleTimeClock"
        @mouseover="mouseOver"
      >
        <img
          v-show="!showTimeClock"
          src="../../../images/menu-time-clock.svg"
          alt="Menu Time Clock"
        />
        <img
          v-show="showTimeClock"
          class="arrow-down-icon"
          src="../../../images/arrow-down.svg"
          alt="Arrow Down"
        />
      </button>
    </div>

    <!-- Time Clock Container -->
    <transition name="fade">
      <div
        class="time-clock-container"
        v-if="showTimeClock"
        :class="{ 'with-header': activeTimesheetJob || activeTimesheetBreak }"
      >
        <div class="clock-widget" :class="clockWidgetStatusClass">
          <div
            class="selected-job"
            v-if="activeTimesheetJob || activeTimesheetBreak"
          >
            <span class="status" :class="{ break: this.status === 4 }"></span>
            <span class="position">{{ jobBreakTimerLabel }}</span>
          </div>
          <div class="content-wrapper">
            <h1>{{ label.get("today") }} &middot; {{ todayDate }}</h1>
            <span class="time-counter" v-if="status !== 0">{{
              timeClockTimer
            }}</span>
            <div class="btn-container">
              <button
                type="button"
                class="pulse ripple-static-content ripple-pulsing-clock"
                :class="clockWidgetStatusClass"
                :disabled="disabledTimeClockBtn"
                @click="toggleTimeClockBtn"
              >
                <div v-if="disabledTimeClockBtn" class="btn-loader" />
                <span v-if="!disabledTimeClockBtn">{{
                  clockBtnStatusLabel
                }}</span>
              </button>
            </div>
            <div class="actions" v-if="status === 1">
              <div class="action">
                <button
                  type="button"
                  :disabled="disabledTimeClockBtn"
                  @click="addNotes"
                >
                  <img src="../../../images/notes.svg" alt="Note" />
                </button>
                <span>{{ label.get("add_notes") }}</span>
              </div>
              <div
                class="action"
                v-if="$store.state.companySettings.break_rule !== 2"
              >
                <button
                  type="button"
                  :disabled="disabledTimeClockBtn"
                  @click="takeBreak"
                >
                  <img src="../../../images/coffee-break.svg" alt="Break" />
                </button>
                <span>{{ label.get("take_break") }}</span>
              </div>
              <div class="action">
                <button
                  type="button"
                  :disabled="disabledTimeClockBtn"
                  @click="toggleJobs"
                >
                  <img
                    src="../../../images/jobs.svg"
                    alt="Job"
                    v-if="!activeTimesheetJob"
                  />
                  <img
                    src="../../../images/switch-jobs.svg"
                    alt="Job Switch"
                    v-if="activeTimesheetJob"
                  />
                </button>
                <span v-if="!activeTimesheetJob">{{
                  label.get("start_job")
                }}</span>
                <span v-if="activeTimesheetJob">{{
                  label.get("switch_job")
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Notes Widget -->
        <notes-widget-component
          v-if="showNotes"
          :note="timesheet.note"
          :timesheet-id="timesheet.id"
          @onNotesClose="onNotesClose"
        />
        <!-- End of: Notes Widget -->

        <!-- Jobs Widget -->
        <jobs-widget-component
          v-if="showJobs"
          :job="activeTimesheetJob"
          @onJobsClose="onJobsClose"
          @onJobAdded="onJobAdded"
          @onJobEnded="onJobEnded"
          @onJobSwitched="onJobSwitched"
        />
        <!-- End of: Jobs Widget -->

        <!-- Jobs Widget -->
        <breaks-widget-component
          v-if="showBreaks"
          :break-code="activeTimesheetBreak"
          @onBreaksClose="onBreaksClose"
          @onBreakAdded="onBreakAdded"
        />
        <!-- End of: Jobs Widget -->
      </div>
    </transition>
    <!-- End of: Time Clock Container -->
  </div>
  <!-- End of: Time Clock Widget -->
</template>

<script>
import TimesheetService from "../timesheets/shared/TimesheetService";
import UtilsService from "../../shared/services/UtilsService";
import NotesWidgetComponent from "./NotesWidgetComponent";
import JobsWidgetComponent from "./JobsWidgetComponent";
import BreaksWidgetComponent from "./BreaksWidgetComponent";

export default {
  name: "TimeClockWidgetComponent",
  components: {
    JobsWidgetComponent,
    NotesWidgetComponent,
    BreaksWidgetComponent,
  },
  data() {
    return {
      visibleTimeClock: !(
        localStorage.getItem("time_clock") &&
        localStorage.getItem("time_clock") === "false"
      ),
      status: 1,
      timesheet: null,
      isClockedIn: false,
      isClockedOut: false,
      isOnBreak: false,
      isOnJob: false,
      disabledTimeClockBtn: false,
      activeTimesheetJob: null,
      activeTimesheetBreak: null,
      jobBreakTimerLabel: null,
      showTimeClock: false,
      showNotes: false,
      showJobs: false,
      showBreaks: false,
      clockWidgetBtn: false,
      showCloseBtn: false,
      showTimer: false,
      todayDate: this.$moment().format("MMM D"),
      timeInSeconds: 0,
      jobBreakTimeInSeconds: 0,
      timer: null,
      jobBreakTimer: null,
    };
  },
  computed: {
    timeClockTimer() {
      return this.$store.state.timeClockTicker;
    },
    breakClockTimer() {
      return this.$store.state.breakClockTicker;
    },
    clockWidgetStatusClass() {
      if (this.status === 1) {
        return "clock-out";
      }
      if (this.status === 4) {
        return "break";
      }
      return "clock-in";
    },
    clockBtnStatusLabel() {
      if (this.status === 1) {
        return this.label.get("clock_out");
      }
      if (this.status === 4) {
        return this.label.get("end_break");
      }
      return this.label.get("clock_in");
    },
  },
  mounted() {
    this.$root.$on("onToggleTimeClock", this.toggleTimeClock);
    const lastTimesheet = this.$store.state.lastTimesheet;
    if (lastTimesheet !== null && lastTimesheet.end === null) {
      this.timesheet = lastTimesheet;
      const diffInSeconds = this.$moment().diff(
        this.$moment.utc(lastTimesheet.start),
        "seconds"
      );

      let breaksDiffInSeconds = 0;
      this.timesheet.breaks.forEach((item) => {
        if (item.end) {
          breaksDiffInSeconds += this.$moment
            .utc(item.end)
            .diff(this.$moment.utc(item.start), "seconds");
        } else {
          breaksDiffInSeconds += this.$moment().diff(
            this.$moment.utc(item.start),
            "seconds"
          );
        }
      });

      this.timeInSeconds = diffInSeconds > 0 ? diffInSeconds : 0;
      this.timeInSeconds -= breaksDiffInSeconds;
      this.startTimer();
      this.showTimeClock = true;
      this.status = 1;
      this.activeTimesheetBreak = this.timesheet.breaks.find(
        (x) => x.end === null
      );
      this.activeTimesheetJob = this.timesheet.jobs.find((x) => x.end === null);
      if (this.activeTimesheetBreak) {
        const diffInSeconds = this.$moment().diff(
          this.$moment.utc(this.activeTimesheetBreak.start),
          "seconds"
        );
        this.jobBreakTimeInSeconds = diffInSeconds > 0 ? diffInSeconds : 0;
        this.status = 4;
        this.pauseTimer();
        this.startJobBreakTimer();
      } else if (this.activeTimesheetJob) {
        const diffInSeconds = this.$moment().diff(
          this.$moment.utc(this.activeTimesheetJob.start),
          "seconds"
        );
        this.jobBreakTimeInSeconds = diffInSeconds > 0 ? diffInSeconds : 0;

        const jobBreaks = this.timesheet.breaks.filter(
          (x) => x.start >= this.activeTimesheetJob.start
        );
        let jobBreaksDiffInSeconds = 0;
        jobBreaks.forEach((item) => {
          if (item.end) {
            jobBreaksDiffInSeconds += this.$moment
              .utc(item.end)
              .diff(this.$moment.utc(item.start), "seconds");
          } else {
            jobBreaksDiffInSeconds += this.$moment().diff(
              this.$moment.utc(item.start),
              "seconds"
            );
          }
        });
        this.jobBreakTimeInSeconds = diffInSeconds - jobBreaksDiffInSeconds;
        this.startJobBreakTimer();
      }
    } else {
      this.status = 0;
    }
  },
  beforeDestroy() {
    this.$root.$off("onToggleTimeClock");
  },
  methods: {
    toggleTimeClock() {
      this.showTimeClock = !this.showTimeClock;
      const timeClock = localStorage.getItem("time_clock");
      if (timeClock && timeClock === "false") {
        localStorage.setItem("time_clock", "true");
        this.visibleTimeClock = true;
      }
    },
    toggleTimeClockBtn() {
      if (!this.$store.state.subscribed && !this.$store.state.onTrial) {
        this.$root.$emit("noSubscription");
        return;
      }

      if (this.status === 0) {
        if (
          this.$store.state.companySettings.require_jobs_on_clock_in &&
          !this.activeTimesheetJob
        ) {
          this.showJobs = true;
          return;
        }

        this.timesheet = {
          local_id: UtilsService.getUUID(),
          start: this.$moment()
            .utc()
            .format("YYYY-MM-DD HH:mm:ss"),
          type: "web_sync",
          fake_start_location: false,
          fake_end_location: false,
          breaks: [],
          jobs: [],
        };
        if (this.activeTimesheetJob) {
          if (!this.activeTimesheetJob.timesheet_local_id) {
            this.activeTimesheetJob.timesheet_local_id = this.timesheet.local_id;
            this.timesheet.start = this.activeTimesheetJob.start;
          }
          this.timesheet.jobs.push(this.activeTimesheetJob);
        }
      } else if (this.status === 1) {
        this.timesheet.end = this.$moment()
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        this.timesheet.type = "web_sync";
        let openTimesheetJob = this.timesheet.jobs.find((x) => x.end === null);
        if (openTimesheetJob) {
          openTimesheetJob.end = this.$moment()
            .utc()
            .format("YYYY-MM-DD HH:mm:ss");
        }
      } else if (this.status === 4) {
        this.activeTimesheetBreak = this.timesheet.breaks.find(
          (x) => x.end === null
        );
        this.activeTimesheetBreak.end = this.$moment()
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        this.disabledTimeClockBtn = true;
        TimesheetService.syncTimesheetBreaks({
          breaks: [this.activeTimesheetBreak],
        })
          .then(() => {
            this.$root.$emit("reloadActivities");
            this.status = 1;
            this.activeTimesheetBreak = null;
            this.jobBreakTimeInSeconds = 0;
            this.stopJobBreakTimer();
            this.startTimer();
            if (this.activeTimesheetJob) {
              const diffInSeconds = this.$moment().diff(
                this.$moment.utc(this.activeTimesheetJob.start),
                "seconds"
              );
              const jobBreaks = this.timesheet.breaks.filter(
                (x) => x.start >= this.activeTimesheetJob.start
              );
              let jobBreaksDiffInSeconds = 0;
              jobBreaks.forEach((item) => {
                if (item.end) {
                  jobBreaksDiffInSeconds += this.$moment
                    .utc(item.end)
                    .diff(this.$moment.utc(item.start), "seconds");
                } else {
                  jobBreaksDiffInSeconds += this.$moment().diff(
                    this.$moment.utc(item.start),
                    "seconds"
                  );
                }
              });
              this.jobBreakTimeInSeconds =
                diffInSeconds - jobBreaksDiffInSeconds;
              this.startJobBreakTimer();
            }
            this.disabledTimeClockBtn = false;
          })
          .catch(() => {
            this.disabledTimeClockBtn = false;
          });
        return;
      }

      this.disabledTimeClockBtn = true;
      TimesheetService.syncTimesheet(this.timesheet)
        .then((response) => {
          this.$root.$emit("reloadActivities");
          this.timesheet.id = response.data.id;

          if (this.status === 1) {
            this.activeTimesheetJob = null;
            this.timesheet = null;
            this.stopJobBreakTimer();
            this.stopTimer();
          } else {
            this.timeInSeconds = 0;
            this.startTimer();
            if (this.activeTimesheetJob) {
              this.jobBreakTimeInSeconds = 0;
              this.startJobBreakTimer();
              this.showJobs = false;
            }
          }
          this.status = this.status === 0 || this.status === 4 ? 1 : 0;
          this.disabledTimeClockBtn = false;
        })
        .catch(() => {
          this.disabledTimeClockBtn = false;
        });
    },
    takeBreak() {
      if (!this.$store.state.subscribed && !this.$store.state.onTrial) {
        this.$root.$emit("noSubscription");
        return;
      }

      if (
        this.$store.state.companySettings.break_rule === 3 &&
        !this.activeTimesheetBreak
      ) {
        this.showBreaks = true;
        return;
      }

      let timesheetBreak = this.activeTimesheetBreak;
      if (!this.activeTimesheetBreak) {
        timesheetBreak = {
          local_id: UtilsService.getUUID(),
          timesheet_local_id: this.timesheet.local_id,
          break_code_id: null,
          start: this.$moment()
            .utc()
            .format("YYYY-MM-DD HH:mm:ss"),
          end: null,
          start_latitude: null,
          start_longitude: null,
          end_latitude: null,
          end_longitude: null,
        };
      }
      this.disabledTimeClockBtn = true;
      TimesheetService.syncTimesheetBreaks({ breaks: [timesheetBreak] })
        .then((response) => {
          this.$root.$emit("reloadActivities");
          this.activeTimesheetBreak = timesheetBreak;
          this.timesheet.breaks.push(timesheetBreak);
          this.status = 4;
          this.jobBreakTimeInSeconds = 0;
          this.pauseTimer();
          this.stopJobBreakTimer();
          this.startJobBreakTimer();
          this.disabledTimeClockBtn = false;
          this.showBreaks = false;
        })
        .catch((error) => {
          this.disabledTimeClockBtn = false;
        });
    },
    addNotes() {
      this.showNotes = true;
    },
    onNotesClose(note) {
      if (note !== undefined) {
        this.timesheet.note = note;
      }
      this.showNotes = false;
    },
    toggleJobs() {
      this.showJobs = true;
    },
    onJobsClose() {
      this.showJobs = false;
    },
    onJobAdded(selectedJob) {
      const timesheetJob = {
        local_id: UtilsService.getUUID(),
        timesheet_local_id: this.timesheet ? this.timesheet.local_id : null,
        job_id: selectedJob,
        start: this.$moment()
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
        end: null,
        start_latitude: null,
        start_longitude: null,
        end_latitude: null,
        end_longitude: null,
      };

      if (
        this.$store.state.companySettings.require_jobs_on_clock_in &&
        !this.timesheet
      ) {
        this.activeTimesheetJob = timesheetJob;
        this.toggleTimeClockBtn();
        return;
      }

      TimesheetService.syncTimesheetJobs({ jobs: [timesheetJob] })
        .then(() => {
          this.activeTimesheetJob = timesheetJob;
          this.timesheet.jobs.push(timesheetJob);
          this.startJobBreakTimer();
          this.showJobs = false;
        })
        .catch(() => {});
    },
    onJobEnded() {
      const timesheetJob = this.timesheet.jobs.find((x) => x.end === null);
      if (timesheetJob) {
        timesheetJob.end = this.$moment()
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        TimesheetService.syncTimesheetJobs({ jobs: [timesheetJob] })
          .then(() => {
            this.activeTimesheetJob = null;
            this.stopJobBreakTimer();
            this.showJobs = false;
          })
          .catch(() => {});
      }
    },
    onJobSwitched(selectedJob) {
      const timesheetJob = this.timesheet.jobs.find((x) => x.end === null);
      if (timesheetJob) {
        timesheetJob.end = this.$moment()
          .utc()
          .format("YYYY-MM-DD HH:mm:ss");
        const newTimesheetJob = {
          local_id: UtilsService.getUUID(),
          timesheet_local_id: this.timesheet.local_id,
          job_id: selectedJob,
          start: this.$moment()
            .utc()
            .format("YYYY-MM-DD HH:mm:ss"),
          end: null,
          start_latitude: null,
          start_longitude: null,
          end_latitude: null,
          end_longitude: null,
        };
        TimesheetService.syncTimesheetJobs({
          jobs: [timesheetJob, newTimesheetJob],
        })
          .then(() => {
            this.activeTimesheetJob = newTimesheetJob;
            this.stopJobBreakTimer();
            this.startJobBreakTimer();
            this.showJobs = false;
          })
          .catch(() => {});
      }
    },
    onBreaksClose() {
      this.showBreaks = false;
    },
    onBreakAdded(breakCode) {
      this.activeTimesheetBreak = {
        local_id: UtilsService.getUUID(),
        timesheet_local_id: this.timesheet.local_id,
        break_code_id: breakCode,
        start: this.$moment()
          .utc()
          .format("YYYY-MM-DD HH:mm:ss"),
        end: null,
        start_latitude: null,
        start_longitude: null,
        end_latitude: null,
        end_longitude: null,
      };

      this.takeBreak();
    },
    disableTimeClockWidget() {
      localStorage.setItem("time_clock", "false");
      this.visibleTimeClock = false;
    },
    timeClockBtnClick() {
      this.showTimer =
        !this.showTimeClock && (this.status === 1 || this.status === 4);
    },
    mouseOver() {
      this.showCloseBtn = true;
    },
    mouseLeave() {
      this.showCloseBtn = false;
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.timeInSeconds++;
        this.$store.commit(
          "timeClockTicker",
          this.prettyTime(this.timeInSeconds)
        );
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
      this.$store.commit("timeClockTicker", null);
    },
    pauseTimer() {
      clearInterval(this.timer);
      this.$store.commit(
        "timeClockTicker",
        this.prettyTime(this.timeInSeconds)
      );
    },
    startJobBreakTimer() {
      if (!this.jobBreakTimer) {
        let label = "";
        if (this.status === 4) {
          label = this.label.get("on_break") + " · ";
          if (this.activeTimesheetBreak.break_code_id) {
            const breakCode = this.$store.state.breakCodes.find(
              (x) => x.id === this.activeTimesheetBreak.break_code_id
            );
            if (breakCode) {
              label = breakCode.name + " · ";
            }
          }
        } else if (this.activeTimesheetJob) {
          const jobCode = this.$store.state.companyJobs.find(
            (x) => x.id === this.activeTimesheetJob.job_id
          );
          if (jobCode) {
            label = jobCode.name + " · ";
          }
        }
        this.jobBreakTimer = setInterval(() => {
          this.jobBreakTimeInSeconds++;
          this.jobBreakTimerLabel = label + this.prettyJobBreakTime();
          if (this.status === 4) {
            this.$store.commit(
              "breakClockTicker",
              this.prettyTime(this.jobBreakTimeInSeconds)
            );
          }
        }, 1000);
      }
    },
    stopJobBreakTimer() {
      clearInterval(this.jobBreakTimer);
      this.jobBreakTimer = null;
      this.jobBreakTimeInSeconds = 0;
      this.$store.commit("breakClockTicker", null);
    },
    prettyTime(timeInSeconds) {
      let hours = Math.floor(timeInSeconds / 3600);
      let minutes = Math.floor((timeInSeconds / 60) % 60);
      let seconds = Math.floor(timeInSeconds % 60);
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return hours + ":" + minutes + ":" + seconds;
    },
    prettyJobBreakTime() {
      let hours = Math.floor(this.jobBreakTimeInSeconds / 3600);
      let minutes = Math.floor((this.jobBreakTimeInSeconds / 60) % 60);
      let seconds = Math.floor(this.jobBreakTimeInSeconds % 60);
      if (hours > 0) {
        return hours + "h " + minutes + "m " + seconds + "s";
      }
      if (minutes > 0) {
        return minutes + "m " + seconds + "s";
      }
      return seconds + "s";
    },
  },
};
</script>

<style scoped lang="scss">
/* @media queries */
@mixin mobile {
  @media (max-width: 480px) {
    @content;
  }
}
@mixin smallHeightDevice {
  @media (max-height: 775px) {
    @content;
  }
}
/* End of: @media queries */

.time-clock-widget {
  .widget-button {
    position: fixed;
    bottom: 32px;
    @include smallHeightDevice {
      bottom: 12px;
    }
    right: 32px;
    @include mobile {
      right: 7px;
    }
    width: auto;
    height: 60px;
    box-shadow: 1px 1px 30px 1px rgba(38, 38, 38, 0.2);
    z-index: 12;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 190px;
    .remove-button {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 7px;
      right: -1px;
      width: 16px;
      height: 16px;
      border-radius: 100%;
      background: #262626;
      &:hover {
        background: #e05656;
      }
    }
    @keyframes fadeInLeft {
      0% {
        opacity: 0;
        transform: translateX(15px);
      }
      100% {
        opacity: 1;
        transform: translateX(0);
      }
    }
    @keyframes fadeInRight {
      0% {
        opacity: 1;
        transform: translateX(0);
      }
      100% {
        opacity: 0;
        transform: translateX(15px);
      }
    }
    .status.fade-enter-active {
      animation: fadeInLeft 0.3s ease-in;
    }
    .status.fade-leave-active {
      animation: fadeInRight 0.3s ease-in;
    }
    .status {
      display: flex;
      align-items: center;
      position: absolute;
      right: 10px;
      width: 200px;
      height: 100%;
      background: #ffffff;
      box-shadow: 1px 1px 30px 1px rgba(38, 38, 38, 0.2);
      border-radius: 190px;
      padding-right: 70px;
      z-index: -1;
      @mixin ringsStatus($duration, $delay, $bg) {
        content: "";
        position: absolute;
        height: 20px;
        width: 20px;
        background: $bg;
        border-radius: 100%;
        animation: $duration rippleStatus $delay infinite;
        opacity: 0;
        z-index: -1;
      }
      @keyframes rippleStatus {
        from {
          opacity: 0.2;
          transform: scale3d(1, 1, 1);
        }
        to {
          opacity: 0;
          transform: scale3d(1.5, 1.5, 1);
        }
      }
      .status-ripple {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        left: 20px;
        width: 8px;
        height: 8px;
        border-radius: 100%;
        background: #06b879;
        &::after {
          @include ringsStatus(4s, 4s, #06b879);
        }
        &::before {
          @include ringsStatus(4s, 0s, #06b879);
        }
        &.on-break {
          background: #fba345;
        }
      }
      .counter {
        margin-left: 45px;
        font-size: 1.25rem;
        line-height: 1.75rem;
        color: #262626;
        font-weight: 500;
        min-width: 78px;
      }
    }
    .widget-icons-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 60px;
      height: 100%;
      background: #00b9cb;
      margin-top: -1px;
      border-radius: 50%;
      cursor: pointer;
      .arrow-down-icon {
        margin-top: 6px;
      }
      &:hover {
        background: #0a9ead;
      }
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(15px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes fadeOut {
    0% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(15px);
    }
  }
  .time-clock-container.fade-enter-active {
    animation: fadeIn 0.3s ease-in;
  }
  .time-clock-container.fade-leave-active {
    animation: fadeOut 0.3s ease-in;
  }
  .time-clock-container.with-header {
    @include smallHeightDevice {
      .clock-widget {
        min-height: 620px;
      }
    }
  }
  .time-clock-container {
    position: fixed;
    bottom: 108px;
    right: 32px;
    width: 380px;
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 1px 1px 20px 10px rgba(38, 38, 38, 0.1);
    z-index: 12;
    overflow: hidden;

    @include mobile {
      width: 95%;
      margin: auto;
      right: 0;
      left: 0;
    }
    @include smallHeightDevice {
      top: 75px;
      bottom: 85px;
      overflow-y: auto;
    }
    .clock-widget {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      min-height: 520px;
      height: 100% !important;
      h1 {
        font-size: 0.875rem;
        line-height: 1rem;
        font-weight: lighter;
        color: #262626;
      }
      @mixin rings($duration, $delay, $bg) {
        content: "";
        position: absolute;
        height: 100%;
        width: 100%;
        background: $bg;
        border-radius: 100%;
        animation: $duration ripple $delay infinite;
        opacity: 0;
        z-index: -1;
      }
      @keyframes pulse {
        0%,
        10%,
        20%,
        30%,
        50%,
        60%,
        80%,
        90%,
        100% {
          transform: scale(1);
        }
        40% {
          transform: scale(1.06);
        }
        70% {
          transform: scale(1.03);
        }
      }
      .ripple-pulsing-clock.pulse {
        animation: 1.2s pulse 0s 1 linear;
      }
      .ripple-static-content {
        z-index: 1;
        span {
          font-size: 1.25rem;
          line-height: 1.5rem;
          color: #ffffff;
          font-weight: bold;
          text-transform: uppercase;
        }
      }
      .ripple-pulsing-clock,
      .ripple-static-content {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin: auto;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 160px;
        height: 160px;
        border-radius: 100%;
      }
      .ripple-pulsing-clock.clock-in {
        background: #06b879;
        .btn-loader {
          border-left-color: #06b879;
        }
        &:hover {
          background: #06b879;
          .btn-loader {
            border-left-color: #06b879;
          }
        }
        &::after {
          @include rings(2s, 0s, #06b879);
        }
        &::before {
          @include rings(2s, 0.4s, #06b879);
        }
      }
      .ripple-pulsing-clock.clock-out {
        background: #e05656;
        .btn-loader {
          border-left-color: #e05656;
        }
        &:hover {
          background: #e05656;
          .btn-loader {
            border-left-color: #e05656;
          }
        }
        &::after {
          @include rings(2s, 0s, #e05656);
        }
        &::before {
          @include rings(2s, 0.4s, #e05656);
        }
      }
      .ripple-pulsing-clock.break {
        background: #fba345;
        .btn-loader {
          border-left-color: #fba345;
        }
        &:hover {
          background: #fba345;
          .btn-loader {
            border-left-color: #fba345;
          }
        }
        &::after {
          @include rings(2s, 0s, #fba345);
        }
        &::before {
          @include rings(2s, 0.4s, #fba345);
        }
      }
      @keyframes ripple {
        from {
          opacity: 1;
          transform: scale3d(1, 1, 1);
        }
        to {
          opacity: 0;
          transform: scale3d(1.5, 1.5, 1);
        }
      }
      .content-wrapper {
        position: relative;
        min-height: 520px;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        .btn-container {
          display: flex;
          height: inherit;
          width: 100%;
          position: absolute;
        }
      }
    }
    .clock-widget.clock-in {
      top: 0;
      left: 0;
      h1 {
        padding: 60px 0;
      }
    }
    .clock-widget.clock-out,
    .clock-widget.break {
      top: 0;
      left: 0;
      h1 {
        padding-top: 60px;
      }
      .time-counter {
        font-size: 2.5rem;
        color: #262626;
        font-weight: 400;
      }
    }
    .clock-widget.clock-out,
    .clock-widget.break {
      .selected-job {
        display: flex;
        align-items: center;
        width: 100%;
        height: 73px;
        background: #fafafa;
        border: 1px solid #efefef;
        padding: 27px;
        .status {
          width: 8px;
          height: 8px;
          background: #06b879;
          border-radius: 100%;
          &.break {
            background: #fba345;
          }
        }
        .position {
          margin-left: 8px;
          font-size: 1rem;
          line-height: 1.5rem;
          color: #262626;
          font-weight: normal;
          text-transform: capitalize;
        }
      }
    }
    .clock-widget.clock-out {
      .actions {
        position: absolute;
        display: flex;
        justify-content: space-around;
        align-items: center;
        bottom: 50px;
        width: 70%;
        height: 90px;
        z-index: 1;
        .action {
          height: 120px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          button {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px;
            height: 60px;
            background: #ffffff;
            border: 2px solid #efefef;
            border-radius: 100%;
            transition: all ease 0.1s;
            &:hover {
              transition: all ease 0.1s;
              background: #f7f7f7;
            }
          }
          span {
            max-width: 90px;
            height: 50px;
            max-height: 50px;
            text-align: center;
            font-size: 0.876rem;
            line-height: 1rem;
            color: #666666;
            font-weight: normal;
            text-transform: capitalize;
            word-break: break-word;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }
}
</style>
